import React from "react";
import "./WelcomeSec.scss";
import WelcomeImage from "../../assets/images/welcome-img-2x.png";
import ScrollDownArrow from "../../assets/images/scroll-down-arrow.svg";
import Blue1Image from "../../assets/images/welcome-blue1.svg";
import YellowImage from "../../assets/images/welcome-yellow.svg";
import PurpleImage from "../../assets/images/welcome-purple.svg";
import WhiteImage1 from "../../assets/images/welcome-white1.svg";
import YellowLines from "../../assets/images/welcome-yellow-lines.svg";
import WhiteImage2 from "../../assets/images/welcome-white2.svg";
import BlueDots from "../../assets/images/welcome-blue-dots.svg";
import Yellow2Image from "../../assets/images/welcome-yellow2.svg";
import Blue2Image from "../../assets/images/welcome-blue2.svg";

const WelcomeSec = () => {
  return (
    <section id="welcomeSection" className="welcomeSec">
      <img src={Blue1Image} alt="blueCircle" className="welcomeSec_blue1" />
      <img src={YellowImage} alt="yellowCircle" className="welcomeSec_yellow" />

      <img src={Yellow2Image} alt="yellow2" className="welcomeSec_yellow2" />
      <img src={Blue2Image} alt="blue2" className="welcomeSec_blue2" />

      <div className="welcomeSec_imagesContainer">
        <img
          src={WhiteImage1}
          alt="whiteCircle"
          className="welcomeSec_white1"
        />
        <img
          src={YellowLines}
          alt="whiteCircle"
          className="welcomeSec_yellowLines"
        />
        <img
          src={PurpleImage}
          alt="purpleCircle"
          className="welcomeSec_purple"
        />
        <img
          src={WhiteImage2}
          alt="whiteCircle"
          className="welcomeSec_whiteImage2"
        />
        <img src={BlueDots} alt="blueDots" className="welcomeSec_blueDots" />
      </div>
      <img src={WelcomeImage} className="welcomeSec_image" alt="welcome" />
      <div className="welcomeSec_content">
        <small>WELCOME TO CREATOR ZONE</small>
        <h1>Ignite Curiosity. Foster Creativity. Empower Innovation.</h1>
        <p>
          Founded in Lake Stevens, WA, Creator Zone is not your run-of-the-mill
          makerspace – it's an immersive nonprofit where self-led discovery
          takes the lead. Our contemporary programs are designed to transport
          participants to a realm where exploration, creativity, and inspiration
          effortlessly merge. We focus on providing children & youth enrichment
          programs, camps and family friendly community events. See upcoming
          events{" "}
          <span
            className="linkStyle"
            onClick={() =>
              document
                ?.getElementById("classes")
                .scrollIntoView({ behavior: "smooth" })
            }
          >
            here
          </span>{" "}
          🚀
        </p>
      </div>
      <img
        id="about"
        className="welcomeSec_scrollArrow"
        src={ScrollDownArrow}
        alt="arrow"
      />
      <div className="welcomeSec_detailsContainer">
        <div className="welcomeSec_details">
          <small>OUR mission</small>

          <h3>Dream - Design - Make </h3>
          <p>
            Our mission is to ignite curiosity, foster creativity, and empower
            innovation through immersive STEM and Art experiences, providing
            access to technology, resources and modern training courses, in
            environments that inspire confidence and skill building.
          </p>

          <h4>What do we offer? </h4>
          <p>
            Creator Zone offers access to a wide variety of tools, materials,
            and creative resources paired with mentorship and guidance to
            explore ideas and learn new skills. Participants have the
            opportunity to engage in DIY projects blending technology, art, and
            engineering. We use an integrated arts model in a makerspace setting
            to provide engaging experiences!{" "}
            <span
              className="linkStyle"
              onClick={() =>
                document
                  ?.getElementById("classes")
                  .scrollIntoView({ behavior: "smooth" })
              }
            >
              Enroll today!
            </span>
          </p>
          {/* <Button white>Become a member</Button> */}
        </div>
        {/* <div className="welcomeSec_details">
          <small>HOW IT WORKS</small>
          <h3>How does it work?</h3>
          <div className="welcomeSec_detailPoint">
            <div className="welcomeSec_detailPointNumber">1</div>
            <div>
              <h4>Discover</h4>
              <p>
                Step inside and explore our diverse array of modern tools and
                equipment. Join us 4-7pm Wednesday evenings for Open House tours
                & sign ups, or{" "}
                <span
                  onClick={() =>
                    document
                      ?.getElementById("membership")
                      .scrollIntoView({ behavior: "smooth" })
                  }
                  style={{ textDecoration: "underline", cursor: "pointer" }}
                >
                  become a member now!
                </span>
              </p>
            </div>
          </div>
          <div className="welcomeSec_detailPoint">
            <div className="welcomeSec_detailPointNumber">2</div>
            <div>
              <h4>Learn</h4>
              <p>
                Once you become a member, attend workshops to learn how to use
                the equipment & develop new skills. Check out our{" "}
                <span
                  onClick={() =>
                    document
                      ?.getElementById("classes")
                      .scrollIntoView({ behavior: "smooth" })
                  }
                  style={{ textDecoration: "underline", cursor: "pointer" }}
                >
                  workshop schedule here
                </span>
              </p>
            </div>
          </div>
          <div className="welcomeSec_detailPoint">
            <div className="welcomeSec_detailPointNumber">3</div>
            <div>
              <h4>Create & Collaborate</h4>
              <p>
                Let your imagination run wild as you turn your ideas into
                reality! Be inspired by the limitless possibilities of
                innovation as you collaborate, learn, and share with others in
                our vibrant, dynamic space.
              </p>
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default WelcomeSec;
